/**
 * File: programmeConsole.js
 * Project: educore
 * Created Date: 2019-03-22
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import viewAttendeesPopup from '../../views/medicalProgramme/programmeAttendeeList.html';
import viewCommentPopup from '../../views/medicalProgramme/programmeCommentList.html';
class ProgrammeConsoleController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService, $mdMedia, $mdDialog) {

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            getDate()
            getProgrammeList()
        }
        let schoolId = localStorageService.get('school_id')
        let userId = localStorageService.get('user_id')
        let academicYear = localStorageService.get('academic_year')

        function getDate() {
            authService.callAPI(MEDICALCONSTANT.API_GET_CURRENT_DATE, "GET", {}, function(response) {
                if (response && response.result && response.result.data) {
                    $scope.serverDate = response.result.data.data
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        function getProgrammeList() {
            let obj = {
                school_id: schoolId,
                academic_year: academicYear,
                user_id: userId
            }
            authService.callAPI(MEDICALCONSTANT.API_GET_CREATED_PROGRAMME, "POST", obj, (response) => {
                if (response.result && response.result.data && response.result.data.data) {
                    if (response.result.data.data.length > 0) {
                        $scope.programmeList = response.result.data.data
                        _.each($scope.programmeList, function(pgm) {
                            pgm.can_publish = true
                            pgm.can_report = false
                            if ($scope.serverDate > pgm.programme_time) {
                                pgm.can_report = true
                                pgm.can_publish = false
                            }
                            if (!pgm.report) {
                                pgm.report = {}
                                pgm.report.messages = [{
                                    name: ''
                                }]
                            }
                        })
                        _.defer(function() {
                            $scope.$apply();
                        });
                    }
                }
            })
        }
        $scope.createProgramme = () => {
            $state.go('createProgramme')
        }

        $scope.collapseHistory = function(expa) {
            $scope.viewReportData = []
            for (var i in $scope.programmeList) {
                if ($scope.programmeList[i] != expa) {
                    $scope.programmeList[i].expanded = false;
                }
            }
            expa.expanded = !expa.expanded;
        };
        $scope.viewAttendees = (pgmData) => {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                locals: {
                    pgmData: pgmData
                },
                template: viewAttendeesPopup,
                controller: ['$scope', '$mdDialog', 'pgmData',
                    function($scope, $mdDialog) {
                        $scope.viewAttendeesArray = pgmData.attendees
                        $scope.cancel = function() {
                            $mdDialog.hide();
                        };
                    }
                ],
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            })
        }
        $scope.publish = (pgmId) => {
            if (pgmId) {
                authService.callAPI(MEDICALCONSTANT.API_PUBLISH_PROGRAMME + userId + '/' + pgmId, "GET", {}, function(response) {
                    if (response && response.result && response.result.data) {
                        toastr.success('Programme published successfully')
                        getProgrammeList()
                        _.defer(function() {
                            $scope.$apply();
                        });
                    } else {
                        toastr.error('Server Interpreted.Please try after some time.')
                    }
                })
            }
        }
        $scope.viewCommments = (pgmData) => {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            let commentlist = []
            _.each(pgmData.attendees, function(eachUser) {
                if (eachUser.feedback) {
                     commentlist.push(eachUser)
                }
            })
            if (commentlist.length > 0) {
                $mdDialog.show({
                    locals: {
                        commentlist: commentlist
                    },
                    template: viewCommentPopup,
                    controller: ['$scope', '$mdDialog', 'commentlist',
                        function($scope, $mdDialog) {
                            $scope.commentlist = commentlist
                            $scope.cancel = function() {
                                $mdDialog.hide();
                            };
                        }
                    ],
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: useFullScreen
                })
            } else {
                var confirm = $mdDialog.confirm()
                    .textContent('No comments found...')
                    .ok('Ok')
                $mdDialog.show(confirm).then(function() {
                    $scope.isAssignUsers = true;
                }, function() {
                    $scope.isAssignUsers = false;
                });
                $scope.isPrompt = true
            }
        }
        $scope.viewImage = (dataUrl) => {
            let useFullScreen = ($mdMedia('sm') || $mdMedia('xs'));
            $scope.imgurl = FILE_UPLOAD_URL + dataUrl
            $mdDialog.show({
                    templateUrl: viewImage,
                    clickOutsideToClose: true,
                    scope: $scope,
                    fullscreen: useFullScreen,
                    preserveScope: true
                })
                .then(function() {

                }, function() {
                    self.status = 'You cancelled the dialog.';
                })
            $scope.$watch(function() {
                return $mdMedia('xs') || $mdMedia('sm');
            }, function(wantsFullScreen) {
                $scope.customFullscreen = (wantsFullScreen === true);
            });
        }
        $scope.addReport = (data, index) => { // shows report form
            $scope.showreportForm = [] //to show form of the particular pgm by index
            $scope.showreportForm[index] = true //show report form
        }
        $scope.addMessagefield = function(data) {
            data.report.messages.push({
                name: ''
            })
        }

        $scope.removeMessagefield = function(data, index) {
            data.report.messages.splice(index, 1)
        }
        $scope.submitReport = (data, index) => {
            $scope.errors = {}
            let errorCount = 0
            $scope.reportData = {
                comment: data.report.comment ? data.report.comment : null,
                messages: data.report.messages,
                mode: data.report.mode ? data.report.mode : null,
                official: data.report.official ? data.report.official : null,
                speaker: data.report.speaker ? data.report.speaker : null,
                supporting_staff: data.report.supporting_staff ? data.report.supporting_staff : null,
                pgm_id: data._id,
                user_id: userId
            }

            if (errorCount === 0) {
                $scope.indexPgm = index
                if ($scope.imgArray) //if there is images
                    $scope.reportData['images'] = $scope.imgArray
                authService.callAPI(MEDICALCONSTANT.API_ADD_REPORT, "POST", $scope.reportData, function(response) {
                    if (response && response.result && response.result.data) {
                        $scope.uploading = ""
                        toastr.success("Report submitted successfully!")
                        $scope.showreportForm = [] //to show form of the particular pgm by index
                        $scope.showreportForm[$scope.indexPgm] = false //hide report form
                        $scope.viewReportData = [] //to view report of the particular pgm by index
                        $scope.viewReportData[$scope.indexPgm] = true //view report
                        getProgrammeList()
                        _.defer(function() {
                            $scope.$apply();
                        });
                    } else {
                        toastr.error('Server Interpreted.Please try after some time.')
                    }
                })
            }
        }
        $scope.setFilePath = function(img) {
            let new_url = FILE_UPLOAD_URL + img
            return new_url
        }
        $scope.viewReport = (data, index) => { // view rport
            if ($scope.viewReportData[index]) {
                $scope.viewReportData[index] = false
            } else {
                $scope.viewReportData[index] = true
            }
        }

        $scope.imgArray = []
        $scope.removeImage = function(index) {
            $scope.imgArray.splice(index, 1)
        }
        $scope.optionImgUpload = function(file, data) {
            _.each(file, function(fileObj) {
                if (fileObj.type === "image/jpg" || fileObj.type === "image/jpeg" || fileObj.type === "image/png") {
                    uploadService.uploadCheckService(fileObj, $scope.serverUrl, $scope.userPath, function(result) {
                        if (result.url) {
                            $scope.imgArray.push(
                                result.url
                            )
                        }
                    })
                } else {
                    toastr.error("Please select the supported format jpg, jpeg, png")
                    fileObj = {}
                }
            })
        }
    }
}
export default ProgrammeConsoleController



// WEBPACK FOOTER //
// ./src/app/medical/controllers/medicalProgramme/programmeConsole.js